import { Box, BoxProps, SxProps, Theme } from "@mui/material";

interface ISpacedContainerProps extends BoxProps {
    sx?: SxProps<Theme>;
}

export const SpacedContainer = ({ children, sx, ...boxProps }: ISpacedContainerProps) => {
    return (
        <Box px={2} pb={2} gap={2} display="flex" flexDirection="column" sx={sx} {...boxProps}>
            {children}
        </Box>
    );
};
